<template>
  <div>
    <div
      v-for="(flashcard, index) in flashcardListStatuses"
      :key="flashcard.id"
      class="table-item"
      tabindex="0"
      @click="handleItemClick(flashcard.id)"
      @keydown.enter.prevent="handleItemClick(flashcard.id)"
    >
      <span>
        <icon
          v-if="flashcard.isBookmarked"
          name="flag-filled"
          class="small-icon"
        ></icon>
        <icon
          v-else
          name="flag-outline"
          class="small-icon"
        ></icon>
        Question {{ index + firstQuestionNumber }}
      </span>
      <span
        v-if="isSimulationComplete"
        :class="{ complete: flashcard.isCorrect, incomplete: !flashcard.isCorrect }"
      >
        {{ flashcard.isCorrect ? "Correct" : "Incorrect" }}
      </span>
      <span
        v-else
        :class="{ complete: flashcard.isAnswered, incomplete: !flashcard.isAnswered }"
      >
        {{ flashcard.isAnswered ? "Complete" : "Incomplete" }}
      </span>
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    flashcardListStatuses: {
      type: Array,
      required: true,
    },
    firstQuestionNumber: {
      type: Number,
      default: 1,
    },
    isSimulationComplete: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleItemClick(flashcardId) {
      this.$emit('navigate', flashcardId);
    },
  },
};
</script>

<style lang='scss' scoped>
.small-icon {
  height: 17px;
  margin-right: 0.5rem;
}

.table-item {
  display: flex;
  justify-content: space-between;
  height: 2rem;
  align-items: center;
  padding: 0 1rem;
  border: 1px solid rgba(196, 196, 196, 1);
  margin-top: -1px;
  margin-left: -1px;
  cursor: pointer;
}

.complete {
  color: rgba(0, 180, 109, 1);
}

.incomplete {
  color: rgba(220, 52, 22, 1);
}

</style>
